<template>
  <router-link class="logo-gray" :to="{ name: `home-${this.$i18n.locale}`, params: { lang: this.$i18n.locale } }">{{ $t('navbar.title') }}</router-link>
</template>
